import { render, staticRenderFns } from "./DynamicButton.vue?vue&type=template&id=0f0637e4&scoped=true"
import script from "./DynamicButton.vue?vue&type=script&lang=js"
export * from "./DynamicButton.vue?vue&type=script&lang=js"
import style0 from "./DynamicButton.vue?vue&type=style&index=0&id=0f0637e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0637e4",
  null
  
)

export default component.exports